import React from "react";
import Admin from "us.collection.admin";

const Cnt_NonProductionDaysHome: React.FC = (props) => {
  return (
    <Admin.Components.NonProductionDays.NonProductionDaysHome {...props} />
  );
};

export default Cnt_NonProductionDaysHome;
